<template>
  <AppModalDialog hash="in-person-closed">
    <AppFormWrapper>
      <h2>In-person Registration Closed</h2>
      <p>
        In-person registration for the VIZBI {{ history.latestYear }} Workshop and Masterclass is
        now closed.
      </p>
      <p>
        However, late registration may be possible &mdash; if you want to attend please
        <a href="mailto:contact@vizbi.org">contact us</a>.
      </p>
    </AppFormWrapper>
    <template #footer>
      <ButtonBespoke outstanding @click="router.replace({hash: ''})">Close</ButtonBespoke>
    </template>
  </AppModalDialog>
</template>

<script setup>
import {useRouter} from "vue-router";
import AppModalDialog from "@/components/App/Modal/Dialog/index";
import AppFormWrapper from "@/components/App/Form/Wrapper";
import ButtonBespoke from "@/components/ButtonBespoke";
import history from "@/assets/history.json";
const router = useRouter();
</script>

<style scoped>
:deep(h2) {
  font-size: 1.92rem;
}
:deep(p) {
  font-size: 1.1rem;
}
</style>
